// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * Bill Memory — the exact words on the Stock In screen (source spec, "Stock In screen behaviour";
 * design D17, D21). One grey line, plain words; no icons, badges or emojis. Pure.
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-09-12" or a Date → "12 Sep" */
function shortDate(d) {
  if (!d) return '';
  const s = typeof d === 'string' ? d.slice(0, 10) : new Date(d).toISOString().slice(0, 10);
  const [, m, day] = s.split('-').map(Number);
  return m && day ? `${day} ${MONTHS[m - 1]}` : '';
}

/** Indian digit grouping without depending on the runtime's locale data: 1234567 → "12,34,567". */
function inr(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return String(n);
  const neg = v < 0;
  const [int, dec] = Math.abs(v).toFixed(2).replace(/\.00$/, '').split('.');
  const last3 = int.slice(-3);
  const rest = int.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  return `${neg ? '-' : ''}${rest ? `${rest},${last3}` : last3}${dec ? `.${dec}` : ''}`;
}

const TEXT = {
  learned_vendor: (p) => `Learned on ${shortDate(p.date)}`,
  learned_shop: (p) => `Learned on ${shortDate(p.date)} (any vendor)`,
  usually_from: (p) => `Usually from ${p.vendor}`,
  dictionary: (p) => `Matched as ${p.item}`,
  learned_once: () => 'Learned once, tap to confirm',
  vendor_leads: (p) => `Usually ${p.item} from ${p.vendor}`,
  sounds_like: (p) => `Sounds like ${p.item}`,
  votes_lead: (p) => `Usually ${p.item}`,
  pack_suits: (p) => `${p.qty} on the bill suits ${p.item}`,
  choose: () => 'Choose the right item',
  new_pack: (p) => `New pack size: ${p.now}, usually ${p.was}`,
  look_alike: () => 'Two lines look alike, check both',
  not_kitchen_item: () => 'Does not look like a kitchen item, check the spelling',
  removed_last_bill: () => 'Removed from the last bill from this vendor',
  maths: (p) => `${inr(p.qty)} × ${inr(p.rate)} ≠ ${inr(p.amount)}, check qty or amount`,
  qty_memory: (p) => `Quantity filled from memory: ${p.from} = ${p.to}. Please check.`,
  left_out: (p) => `Left out as usually not stock: ${p.name} ₹${inr(p.amount)}. Add back`,
  ready: (p) => `${p.ready} of ${p.total} ready, ${p.need} ${Number(p.need) === 1 ? 'needs' : 'need'} a tap`,
  need_tap: (p) => `${p.need} ${Number(p.need) === 1 ? 'item needs' : 'items need'} a tap`,
  none_of_these: () => 'None of these, add as new',
  who_from: () => 'Who is this bill from?',
  gstin_vendor: (p) => `This bill's GSTIN belongs to ${p.vendor}`,
};

function reasonText(code, params) {
  const f = TEXT[code];
  return f ? f(params || {}) : '';
}

/** "How it learned" — a lesson's source in words, on the Bill Memory page and in its export (Fix 13). */
const HOW_LEARNED = Object.freeze({
  scan: 'Bill scan', excel: 'Excel', typed: 'Typed by hand', dictionary: 'Dictionary, accepted', line_deleted: 'Line deleted',
  import_lines: 'Imported from history', import_vih: 'Imported from history', import_history: 'Imported from history',
  added_back: 'Added back', manual: 'Added by hand', restored: 'Restored',
});

/** howLearned('added_back') → 'Added back'; a source without words is shown as it is. */
function howLearned(source) {
  return HOW_LEARNED[source] || (source == null ? '' : String(source));
}

export { reasonText, shortDate, inr, HOW_LEARNED, howLearned };
